import Sort from '../../stores/Sort';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetPackageDeals = (enabled = false) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-package-deals'],
        queryFn: async () => {
            const response = await zoneApiClient.getPackageSettlements();

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve package deals.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            const data = response.payload;
            data?.sort(Sort.compareValues('name', undefined, 'asc'));

            return data;
        },
        enabled: enabled
    });
};
